import GradientTop from '../../atoms/mask/gradientTop';
import GradientBottom from '../../atoms/mask/gradientBottom';
import { GradientProps as Props } from '../../../../shared/types/props/image';

function Gradient({ opacity = 1, height = 387 }: Props) {
  return (
    <>
      <GradientTop opacity={opacity} height={height} />
      <GradientBottom opacity={opacity} height={height} />
    </>
  );
}

export default Gradient;
